import { render, staticRenderFns } from "./cateredStudentOrder.vue?vue&type=template&id=71b4b03b&scoped=true&"
import script from "./cateredStudentOrder.vue?vue&type=script&lang=js&"
export * from "./cateredStudentOrder.vue?vue&type=script&lang=js&"
import style0 from "./cateredStudentOrder.vue?vue&type=style&index=0&id=71b4b03b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4b03b",
  null
  
)

export default component.exports